import geHeroHome from '../assets/images/ge-hero-home.jpeg';
import geHeroHomeSmall from '../assets/images/ge-hero-home-small.jpeg';
import ge1 from '../assets/images/ge-1.jpeg';
import ge3 from '../assets/images/ge-3.jpeg';
import ge5 from '../assets/images/ge-5.jpeg';
import ge6 from '../assets/images/ge-6.jpeg';
import ge7 from '../assets/images/ge-7.jpg';
import ge8 from '../assets/images/ge-8.jpg';
import ge9 from '../assets/images/ge-9.jpeg';
import ge10 from '../assets/images/ge-10.jpeg';
import ge11 from '../assets/images/ge-11.jpeg';
import ge12 from '../assets/images/ge-12.jpeg';
import ge13 from '../assets/images/ge-13.jpeg';
import den from '../assets/images/den.jpeg';
import farm from '../assets/images/farm.png';
import des from '../assets/images/des.png';
import CEO from '../assets/images/CEO.jpeg';

export const images = {
  geHeroHome,
  geHeroHomeSmall,
  ge1,
  ge3,
  ge5,
  ge6,
  ge7,
  ge8,
  ge9,
  ge10,
  ge11,
  ge12,
  ge13,
  den,
  farm,
  des,
  CEO,
};
